import { flash } from "@xola/ui-kit";
import { FormField, SwitchField } from "common";
import { FormikProps } from "formik";
import React, { useRef } from "react";
import { useMutation } from "react-query";
import { TaxAssessedOn } from "types";
import { api } from "../../../api/api";
import { useSeller } from "../../../hooks/useAccount";
import { useInvalidate } from "../../../hooks/useInvalidation";
import { XolaFormik } from "../../Common/XolaFormik";

interface FormValues {
    taxAssessedOn: TaxAssessedOn;
}

export const TaxesAndFeesPreferences = () => {
    const seller = useSeller();
    const invalidate = useInvalidate();
    const preferencesFormRef = useRef<FormikProps<FormValues>>(null);

    const { mutateAsync: savePreference } = useMutation(async (taxAssessedOn: TaxAssessedOn) => {
        await api.post(`/users/${seller.id}/preferences/payment`, {
            taxAssessedOn,
        });
    });

    const handleSubmit = async (values: FormValues) => {
        try {
            await savePreference(values.taxAssessedOn);
            invalidate("sellers", seller.id);
            flash.success("Tax settings saved");
        } catch {
            preferencesFormRef.current?.setFieldValue("taxAssessedOn", seller.preferences.payment.taxAssessedOn);
        }
    };

    const initialValues: FormValues = {
        taxAssessedOn: seller.preferences.payment.taxAssessedOn,
    };

    return (
        <XolaFormik
            enableReinitialize
            initialValues={initialValues}
            innerRef={preferencesFormRef}
            onSubmit={handleSubmit}
        >
            {({ values, handleSubmit, setFieldValue }) => {
                return (
                    <div className="my-14 flex justify-between">
                        <h2>Tax Preferences</h2>
                        <FormField name="taxAssessedOn" label="" className="w-3/4">
                            <div className="flex flex-col">
                                <SwitchField
                                    isChecked={values.taxAssessedOn === TaxAssessedOn.PROMOTIONAL_VALUE}
                                    onChange={(value) => {
                                        setFieldValue(
                                            "taxAssessedOn",
                                            value ? TaxAssessedOn.PROMOTIONAL_VALUE : TaxAssessedOn.PURCHASE_VALUE,
                                        );
                                        handleSubmit();
                                    }}
                                >
                                    <div className="text-md font-bold">Tax Promotional Value</div>
                                </SwitchField>
                                <div className="ml-10 text-gray-darker">
                                    <span>
                                        When enabled, taxes and fees will be assessed on the promotional value of gifts
                                        and vouchers. When disabled, taxes and fees will be assessed on the purchase
                                        value of gifts and vouchers. The promotional component will be treated as a
                                        discount. All existing bookings will not be affected when this setting is
                                        changed.
                                    </span>
                                </div>
                            </div>
                        </FormField>
                    </div>
                );
            }}
        </XolaFormik>
    );
};
